
/* eslint-disable react/require-default-props */
/* eslint-disable max-len */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { Col, Row, Label } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import { getSchema } from '../../redux/actions';
import CustomFields from '../../../../components/customFields/CustomFields';
import PulpoField from '../../../../pulpo_visualizer/fields';
import styles from '../../badging.module.scss';
import Disqulifiers from './Disqulifiers';

const Step1 = ({
  handleFieldErrorChanged,
  showFormErrors,
  handleAnswerChanged,
  requiredMap,
  fields,
  response,
  agreements,
  form,
  additional_info,
  applicationData,
  renewalApplicationData,
  checkboxSectionError
}) => {
    const [disqulifiers, setDisqualifiers] = useState({ default: Disqulifiers, custom: [] });
    const badging = useSelector(state => state.badging);

    const dispatch=useDispatch();

    useEffect(() => {
        dispatch(getSchema());
    }, [dispatch]);

    useEffect(() => {
        if (badging?.action?.success) {
            const customDisqualifiers = badging?.schema?.schema?.disqualifier_checklist || {};
            const transformedData = Object.keys(customDisqualifiers).map(key => ({
                title: customDisqualifiers[key],
                label: customDisqualifiers[key],
                stateKey: 'multipleRemarks',
                id: parseInt(key, 10)
            }));

            setDisqualifiers(prevState => ({
                ...prevState,
                custom: transformedData
            }));
        }
      // eslint-disable-next-line react-hooks/exhaustive-deps
      }, [badging?.action?.success, badging?.schema?.schema?.disqualifier_checklist, dispatch]);


    const renderCheckboxes = (violations, additionalInfo) => violations.map((violation) => {
          if (violation?.sub) {
            return (
              <div key={violations?.id} style={{ margin: '10px' }}>
                <p>{violation.label}</p>
                {violation.sub.map(subViolation => (
                  <div style={{ margin: '10px' }}>
                    <input
                      name={subViolation.title}
                      type="checkbox"
                      onChange={() => handleAnswerChanged(
                          'additional_info',
                          !additionalInfo?.[0]?.[subViolation.stateKey]?.[subViolation.title],
                          subViolation.title,
                          'subCheckbox'
                        )
                      }
                      value
                      defaultChecked={additionalInfo?.[0]?.[subViolation.stateKey]?.[subViolation.title]}
                    />
                    {`  ${subViolation.label}`}
                  </div>
                ))}
              </div>
            );
          }

          // Regular checkboxes
          return (
            <div key={violations?.id} style={{ margin: '10px' }}>
              <input
                name={violation.title}
                type="checkbox"
                onChange={() => handleAnswerChanged(
                    'additional_info',
                    !additionalInfo?.[0]?.[violation.stateKey]?.[violation.title],
                    violation.title,
                    'isCheckbox'
                  )
                }
                value
                defaultChecked={additionalInfo?.[0]?.[violation.stateKey]?.[violation.title]}
              />{' '}
              {violation.label}
            </div>
          );
        });

      const CheckboxForm = additionalInfo => (
        <div>
          <Row>
            <Col lg={6} md={6}>
              <div style={{ border: '1px solid lightgrey', height: '1000px', overflow: 'auto' }}>
                {renderCheckboxes(disqulifiersChecklist?.slice(0, 21), additionalInfo)}
              </div>
            </Col>

            <Col lg={6} md={6}>
              <div style={{ border: '1px solid lightgrey', height: '1000px', overflow: 'auto' }}>
                {renderCheckboxes(disqulifiersChecklist?.slice(21), additionalInfo)}
              </div>
            </Col>
          </Row>
        </div>
      );

      const disqulifiersChecklist = [...(disqulifiers?.default || []), ...(disqulifiers?.custom || [])];

    return (
 <>
    {(applicationData && applicationData?.checkbox_section === true || form?.settings?.checkbox_section === true) && (
    <>
   <div style={{ backgroundColor: '#3A61A8', height: '35px', padding: '5px 15px' }}>
     <p style={{ color: '#FFF' }}>DISQUALIFYING CRIMINAL OFFENSES – SIDA/SECURED/STERILE/AOA ONLY</p>
   </div>
   <div>
     <p style={{ marginTop: '15px' }}>FAR §1542.209 (d) An individual has a disqualifying offense if the individual has been convicted, or found not guilty of or by reason of insanity,
        of any of the disqualifying crimes listed in this paragraph in any jurisdiction during the 10 years before the date of the individual’s application
        for unescorted access authority, or while the individual has unescorted access authority.
     </p>
     <p style={{ marginTop: '10px', fontWeight: 'bold' }}>HAVE YOU BEEN CONVICTED, OR FOUND NOT GUILTY BY REASON OF INSANITY OF ANY OF THE FOLLOWING IN THE PAST 10 YEARS? (Mark
        any that apply)
     </p>
   </div>

   { additional_info && CheckboxForm(additional_info)}

        <div style={{ marginTop: '15px', marginLeft: '40%', display: 'flex' }}>
            <input
                name="noneCheckbox"
                type="checkbox"
                onChange={() => handleAnswerChanged('additional_info', !additional_info[0]?.noneCheckbox, 'noneCheckbox')
                }
                checked={additional_info[0]?.noneCheckbox}
                disabled={(additional_info && additional_info[0] && (Object.values(additional_info[0]?.multipleRemarks).includes(true) || Object.values(additional_info[0]?.felonyInvolvingRemarks).includes(true)))}

            />
            <h4 className="text-center ml-2 mb-4">None</h4>
        </div>

        {checkboxSectionError && (
        <div className={styles.error}>
            <FormattedMessage id="pulpoforms.errors.not_blank1" defaultMessage="Please Select One of the checkbox from above section." />
        </div>
        )}

        <div>
            <p className="mt-4">Federal regulations under 49 CFR 1542.209(I) impose a continuing obligation to disclose to the airport operator within 24 hours if he or she is convicted of
                any disqualifying criminal offense that occurs while he or she has unescorted access authority.
            </p>
            <p className="mt-3">By signing this application below I acknowledge that I have not been convicted or found not guilty by reason of insanity of any of the disqualifying
                criminal offenses listed within the last 10 years, nor have I been arrested for any of the disqualifying offenses and am awaiting judicial proceedings.
                Additionally, by signing this application below I acknowledge that I will notify {form?.airport_data?.name} within 24 hours if I am convicted or found not guilty by reason of
                insanity of any disqualifying criminal offense while I have unescorted access authority.
            </p>
            <p className="mt-3">If the background check contains any outstanding warrant(s) for your arrest for any offense(s) , whether disqualifiable or not, your security badge will
                be denied until such time as documentation is provided to the ASC that said warrant(s) have been cleared from your record and are no longer active.
            </p>
        </div>
    </>
        )}

        <div style={{ marginTop: '40px', backgroundColor: '#3A61A8', height: '35px', padding: '5px 15px' }}>
            <p style={{ color: '#FFF' }}>AGREEMENTS</p>
        </div>

        <div className="mt-2">
            {form?.settings?.badge_agreements?.length > 0
            && form?.settings?.badge_agreements?.map(eachAgreement => (
                <>
                <p style={{ marginBottom: '0px' }}><b>{eachAgreement?.agreement_title} – </b>
                {eachAgreement?.agreement_description}
                </p>
                {eachAgreement?.link !== 'https://' && (
                  <>
                  <a href={eachAgreement.link} target="_blank" rel="noopener noreferrer">
                    {eachAgreement.link}
                  </a>
                  <br />
                  </>
                )}
                <Label for="link">Initial</Label>
                <div style={{ marginBottom: '20px' }}>
                  <input
                      name={eachAgreement?.agreement_title}
                      id={eachAgreement?.agreement_title}
                      type="text"
                      onChange={e => handleAnswerChanged('additional_info', e.nativeEvent.target.value, eachAgreement?.agreement_title, 'agreements')}
                      value={additional_info[0].agreements[eachAgreement?.agreement_title]}
                  />
                </div>
                </>
            ))
            }
            <p>The information I have provided on this application is true, complete and correct to the best of my knowledge and belief and is provided in
                good faith. I understand that a knowing and willful false statement on this application can be punished by a fine or imprisonment or both.
                (Section 1001 of Title 18 USC)
            </p>
        </div>
        <div>
            {Object.keys(requiredMap).length > 0 && fields && fields.length>0 &&(
                <CustomFields
                handleAnswerChanged={(a, b) => handleAnswerChanged('response', a, b)
                }
                handleFieldErrorChanged={handleFieldErrorChanged}
                showFormErrors={showFormErrors}
                requiredMap={requiredMap}
                fields={
                    fields.filter(n => n.id === 'signature')
                }
                answers={response}
                renewalApplicationData={renewalApplicationData}
                />
            )}
            <Row>
            <Col lg={3}>
                <PulpoField
                key="date"
                id="date"
                type="date"
                translationID="job.settings.type_name"
                title="Date"
                isRequired
                handleValueChange={(a, b) => handleAnswerChanged(a, b)}
                answer={agreements?.date}
                handleFieldErrorChanged={handleFieldErrorChanged}
                showFieldErrors={showFormErrors}
            />
            </Col>
            </Row>
        </div>
 </>
);
};


Step1.propTypes = {
    multipleRemarks: [],
    felonyInvolvingRemarks: [],
    agreements: [],
    handleFieldErrorChanged: PropTypes.func.isRequired,
    showFormErrors: PropTypes.bool.isRequired
};

export default Step1;
